import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("token");
    if (!t) { setLoading(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem("token"); setUser(null);
    }).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    if (r.data.two_factor_required) {
      // Étape 1/2 — pas de token tant que /login/2fa pas validé
      return { two_factor_required: true, user_id: r.data.user_id, email: r.data.email };
    }
    localStorage.setItem("token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const verify2FA = async (user_id, code) => {
    const r = await api.post("/auth/login/2fa", { user_id, code });
    localStorage.setItem("token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const registerMember = async (payload) => {
    const r = await api.post("/auth/register-member", payload);
    localStorage.setItem("token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => { localStorage.removeItem("token"); setUser(null); };

  return (
    <AuthCtx.Provider value={{ user, loading, login, verify2FA, registerMember, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
